import { useState } from 'react'
import { Icon, categoryIcons } from './Icons'
import '../styles/IconPicker.css'

function IconPicker({ value, onChange, label = 'Icon' }) {
  const [isOpen, setIsOpen] = useState(false)

  const selectedIcon = categoryIcons.find(i => i.id === value) || categoryIcons[categoryIcons.length - 1]

  const handleSelect = (iconId) => {
    onChange(iconId)
    setIsOpen(false)
  }

  return (
    <div className="icon-picker">
      <label className="icon-picker-label">{label}</label>
      <button
        type="button"
        className="icon-picker-trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="icon-picker-preview">
          <Icon name={selectedIcon.id} size={24} />
        </span>
        <span className="icon-picker-name">{selectedIcon.label}</span>
        <span className="icon-picker-arrow">{isOpen ? '▲' : '▼'}</span>
      </button>

      {isOpen && (
        <div className="icon-picker-dropdown">
          <div className="icon-picker-grid">
            {categoryIcons.map((icon) => (
              <button
                key={icon.id}
                type="button"
                className={`icon-picker-option ${value === icon.id ? 'selected' : ''}`}
                onClick={() => handleSelect(icon.id)}
                title={icon.label}
              >
                <Icon name={icon.id} size={24} />
                <span className="icon-option-label">{icon.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default IconPicker
